import React from 'react'
import Typography from '../../../components/Typography'
import { Link, Box as MuiBox, styled } from '@mui/material'

const Box = styled(MuiBox)({
  display: 'flex',
  gap: '16px',
})

interface TitleWithLinkProps {
  title: string
  linkTitle: string
  linkTo: () => void
  testId?: string
}
export const TitleWithLink = ({ title, linkTitle, linkTo, testId }: TitleWithLinkProps) => {
  return (
    <Box>
      <Typography variant='h4' component='h3' color='primary500'>
        {title}
      </Typography>
      <Link onClick={linkTo} variant='body2' data-testid={testId}>
        {linkTitle}
      </Link>
    </Box>
  )
}
